import { Navigate, useParams } from "react-router";
import { paths } from "@shared-core/routing/routes";

// `/basket/placed/:orderNo` is where an earlier build sent a person after checkout (and where a card payment could
// return to). Checkout now lands on the signed-in order page (Brad, 9 Oct), so an address that is still out there,
// bookmarked or in an email, goes to that order's page.
export function PortalOrderPlacedRedirect() {
  const { orderNo = "" } = useParams<{ orderNo: string }>();
  return (
    <Navigate to={paths.portalOrderDetail({ orderId: orderNo })} replace />
  );
}
